import { Skeleton, styled } from '@mui/material';
import clsx from 'clsx';

import { useSelectedInvestorAccount } from 'hooks';

const SSkeleton = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  height: '66px',

  '&:not(.table-layout)': {
    height: '443px',

    '&.view-only': {
      height: '379px !important',
    },
  },
}));

interface Props {
  tableLayout?: boolean;
}

export const SecondaryDealRecordSkeleton = ({ tableLayout }: Props) => {
  const { isViewOnly } = useSelectedInvestorAccount();

  return (
    <SSkeleton
      variant="rounded"
      className={clsx({ 'table-layout': tableLayout }, { 'view-only': isViewOnly })}
    />
  );
};
